import { Link } from 'react-router-dom'
import { Alert } from '../components/Alert'

/** Deliberately empty: the PRD lists Rules in the IA (§5.1) with no requirements. */
export function RulesPage() {
  return (
    <div className="wrap">
      <div className="phead">
        <div>
          <div className="crumb">
            <Link to="/app">Home</Link> / Rules
          </div>
          <h2>Rules</h2>
        </div>
        <span className="spacer" />
        <span className="tagp t-p1">Planned</span>
      </div>

      <div className="card card-p" style={{ textAlign: 'center', padding: '56px 40px' }}>
        <div className="state">
          <div className="ei">⚖</div>
          <h3 style={{ fontFamily: 'var(--serif)', fontSize: 20, margin: '0 0 8px' }}>
            Rules are not built yet
          </h3>
          <p className="muted" style={{ maxWidth: 520, margin: '0 auto 20px', lineHeight: 1.7 }}>
            Rules will let you set conditions that run on every import: skip a row when a column is
            blank, default a class from the customer name, or route a line to a different account.
            Requirements for this screen are still open in the PRD.
          </p>
          <div className="row" style={{ justifyContent: 'center' }}>
            <Link className="btn btn-o" to="/app/mappings">
              Use a saved mapping instead
            </Link>
            <Link className="btn btn-g" to="/app">
              ← Back to home
            </Link>
          </div>
        </div>
      </div>

      <Alert tone="info" title="Note for the review" style={{ marginTop: 18 }}>
        This entry exists in the PRD information architecture (§5.1) but has no requirements written
        against it. The placeholder is deliberate so the gap stays visible rather than being invented
        here.
      </Alert>
    </div>
  )
}
